import LegalPage from './LegalPage';
import { termsBlocks } from './legalBlocks';

export default function TermsPage() {
  return <LegalPage blocks={termsBlocks} />;
}
